<template>
	<div class="inline-box" @click="toggleSidePop()">
		<svg-icon :icon-class="icon" />
		<section class="info-cls" v-if="isShow">
			<div class="status">网络连接{{text}}</div>
			<div class="cell" v-show="text != '异常'">
				<span>延迟</span>
				<span>{{delay_time}} 毫秒</span>
			</div>
			<!-- <div class="cell">
				<span>丢包率</span>
				<span class="sjt">0.0%</span>
			</div>
			<div class="cell">
				<span></span>
				<span class="xjt">0.0%</span>
			</div> -->
		</section>
	</div>
</template>

<script>
import { mapState } from 'vuex'
export default {
	name: 'NetworkTip',
	computed:{
		...mapState({
			status:state => state.wsSocket.socketStatus,
			lastTime:state => state.wsSocket.lastTime,
			sendTime:state => state.wsSocket.sendTime,
		})
	},
	watch:{
		'sendTime':{
			handler(val){
				if(val){
					if(this.status){
						let last_time = this.lastTime + 3000;
						let time = Math.abs(last_time - this.sendTime);
						this.delay_time = time;
						this.setText(this.delay_time)
					}else {
						this.icon = this.icons[0].icon
						this.text = this.icons[0].key
					}
				}
			},
			immediate:true
		}
	},
	data() {
		return {
			isShow: false,
			delay_time:0,
			icon:'wifi1',
			text:'异常',
			icons:[
				{key:'异常',icon:'wifi1'},
				{key:'差',icon:'wifi2'},
				{key:'偏弱',icon:'wifi3'},
				{key:'正常',icon:'wifi4'}
			]
		}
	},
	methods: {
		toggleSidePop() {
			this.isShow = !this.isShow;
			setTimeout(()=> {
				this.isShow = false
			},3000)
		},
		setText(time){
			if(time < 3000) {
				this.icon = this.icons[3].icon
				this.text = this.icons[3].key
			}else if(time < 6000) {
				this.icon = this.icons[2].icon;
				this.text = this.icons[2].key;
			}else if(time < 8000) {
				this.icon = this.icons[1].icon;
				this.text = this.icons[1].key;
			}else {
				this.icon = this.icons[0].icon;
				this.text = this.icons[0].key;
			}
			
		}
	}
}
</script>

<style lang="scss" scoped>
.inline-box{
	display: inline-block;
	padding: 0 3px;
	font-size: 24px;
	vertical-align: text-bottom;
	position: relative;
	vertical-align: top;
	cursor: pointer;

	& > .info-cls {
		width: 120px;
		position: absolute;
		top: 65px;
		left: -40px;
		font-size: 12px;
		color: #3C4353;
		background: #FFFFFF;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.3);
		border-radius: 4px;
		padding: 10px;
		box-sizing: border-box;
		z-index: 9999999;

		&:before {
			content: '';
			width: 0;
			height: 0;
			border: 5px solid transparent;
			border-bottom-color: rgba(0, 0, 0, 0.1);
			position: absolute;
			top: -10px;
			left: 50px;
		}

		&:after {
			content: "";
			width: 0;
			height: 0;
			border: 5px solid transparent;
			border-bottom-color: #fff;
			position: absolute;
			top: -9px;
			left: 50px;
		}

		& > .status {
			width: 100%;
			line-height: 20px;
			font-size: 13px;
			font-weight: 500;
			margin-bottom: 10px;
		}

		& > .cell {
			width: 100%;
			line-height: 20px;

			& > span:nth-of-type(1) {
				width: 40px;
				display: inline-block;
			}
			& > span:nth-of-type(2) {
				width: 60px;
				display: inline-block;
				text-align: right;
				position: relative;
			}

			& .sjt::before {
				content: "⬆";
				position: absolute;
				top: 0;
				left: 15px;
			}

			& .xjt::before {
				content: "⬇";
				position: absolute;
				top: 0;
				left: 15px;
			}
		}
	}
}

</style>
